// components/LandingModal.jsx

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom'; // Import ReactDOM for the portal
import landingStyles from './LandingModal.module.css'; // Import specific styles for Landing Modal
import blurStyles from '/styles/BlurBackground.module.css'; // Import styles for blur background
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import FontAwesomeIcon component
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'; // Correct import of the 'times circle' icon

const LandingModal = ({ isOpen, onClose }) => {
  const [modalContainer, setModalContainer] = useState(null);

  useEffect(() => {
    // This will run once after the component mounts
    const container = document.getElementById('modal-root');
    setModalContainer(container);
  }, []);

  // Return null if modal is not open or container is not available
  if (!isOpen || !modalContainer) return null;

  // Modal content to be rendered
  const modalContent = (
    <div className={landingStyles['landing-modal']} role="dialog" aria-modal="true" aria-labelledby="landing-modal-title">
      {/* Close button */}
      <button className={landingStyles['landing-modal-close']} onClick={onClose} aria-label="Close modal">
        <FontAwesomeIcon icon={faTimesCircle} size="2x" />
      </button>

      <div className={landingStyles['landing-modal-url-bar-top']}>
        <div className={landingStyles['landing-modal-url']}>
          <center>ShuffleDB.com</center>
        </div>
      </div>

      <div className={landingStyles['landing-modal-title']}>
        A COMPREHENSIVE COLLECTION OF<br /> SHUFFLE DANCE MOVES
      </div>

      <div className={landingStyles['landing-modal-image-bar']}></div>
      <div className={landingStyles['landing-modal-bullets']}>
        {/* Add bullet points here */}
      </div>
      <div className={landingStyles['email-submit']}>
        <form id="emailForm">
          <center>
            <input type="email" className={landingStyles['modal-email']} placeholder="Your email" name="email" required />
          </center>
          <center>
            <button type="submit" className={landingStyles.getMovesButton}>Get The Moves</button>
          </center>
        </form>
      </div>
      <div className={landingStyles['landing-modal-url-bar-bottom']}>
        <div className={landingStyles['landing-modal-url']}>
          <center>ShuffleDB.com</center>
        </div>
      </div>
    </div>
  );

  // Render the modal in a portal
  return ReactDOM.createPortal(modalContent, modalContainer);
};

export default LandingModal;
